
import { profileApi } from './user/profile';
import { friendsApi } from './user/friends';
import { blocksApi } from './user/blocks';
import { searchApi } from './user/search';
import { interestsApi } from './user/interests';
import { avatarsApi } from './user/avatars';
import { groupsApi } from './user/groups';

export { consentApi } from './user/consent';
export type {
  ConsentRecord,
  ConsentState,
  ConsentStateEntry,
  ConsentType,
  ConsentMethod,
  RecordConsentInput,
} from './user/consent';

export const userApi = {
  ...profileApi,
  ...friendsApi,
  ...blocksApi,
  ...searchApi,
  ...interestsApi,
  ...avatarsApi,
  ...groupsApi,
};
